import { render } from "./UnitsIcon.vue?vue&type=template&id=cd5addd0&scoped=true"
import script from "./UnitsIcon.vue?vue&type=script&lang=js"
export * from "./UnitsIcon.vue?vue&type=script&lang=js"

import "./UnitsIcon.vue?vue&type=style&index=0&id=cd5addd0&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd5addd0"]])

export default __exports__